<template>
  <div :class="{ visible: isVisible, invisible: !isVisible }" class="absolute right-0 w-56 origin-top-right outline-none">
    <template v-if="!useShow">
      <template v-if="isVisible"><slot /></template>
    </template>
    <template v-else>
      <template v-show="isVisible"><slot /></template>
    </template>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    /**
     * Bu prop popper component'inin v-if yerine v-show ile render edilmesini kontrol ediyor.
     * @info Seo icin use-show true olmali.
     */
    useShow: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style></style>
